import React from 'react';
import { Block } from 'baseui/block';
import { Cell } from 'baseui/layout-grid';

export const Spacer = () => <Block height="16px" />;
export const SpacerCell = ({ skip, span }) => <Cell skip={skip} span={span} />;